import { Avatar as MantineAvatar } from '@mantine/core'
import { IconUserCircle } from '@tabler/icons-react'
import styles from './Avatar.module.css'

// ─────────────────────────────────────────────
// 型定義
// ─────────────────────────────────────────────
export type AvatarSize = 'XLarge' | 'Large' | 'Medium' | 'Small' | 'XSmall' | 'Mini'

export type AvatarProps = {
  /** アバター画像の URL（未指定時はプレースホルダーを表示） */
  src?: string
  /** 画像の alt テキスト */
  alt?: string
  /** サイズ（デフォルト: 'Medium'） */
  size?: AvatarSize
  className?: string
}

// ─────────────────────────────────────────────
// サイズマップ
// ─────────────────────────────────────────────
const SIZE_PX: Record<AvatarSize, number> = {
  XLarge: 64,
  Large: 58,
  Medium: 48,
  Small: 36,
  XSmall: 32,
  Mini: 24,
}

// ─────────────────────────────────────────────
// プレースホルダー SVG（Figma デザイン準拠の人物アイコン）
// ─────────────────────────────────────────────
const PlaceholderIcon = () => <IconUserCircle size="100%" stroke={1.5} color="#CBCBCE" aria-hidden="true" />

// ─────────────────────────────────────────────
// コンポーネント
// ─────────────────────────────────────────────
/**
 * ユーザーアバターコンポーネント。
 * src 未指定時はプレースホルダーアイコンを表示する。
 *
 * @example
 * <Avatar src="/path/to/image.png" size="Medium" alt="ユーザー名" />
 * <Avatar size="Small" />
 */
export const Avatar = ({ src, alt = '', size = 'Medium', className }: AvatarProps) => {
  return (
    <MantineAvatar
      src={src || null}
      alt={alt}
      size={SIZE_PX[size]}
      classNames={{ root: styles.root, placeholder: styles.placeholder }}
      className={className}
    >
      {!src && <PlaceholderIcon />}
    </MantineAvatar>
  )
}
